import { Component, Inject, ChangeDetectorRef, ViewChild, TemplateRef } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { JwksValidationHandler, NullValidationHandler } from 'angular-oauth2-oidc';
import { Router, RouteConfigLoadStart, RouteConfigLoadEnd, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { SignalRService } from './services/signalr/signal-rservice.service';
import { MENU_ITEMS } from './app-menu';
import { LOCAL_STORAGE, StorageService, BooleanStorageTranscoder } from 'ngx-webstorage-service';
import { IdentityAuthService } from '@services/identity-auth/identity-auth.service';
import { trigger, state, style, animate, transition, group, query } from '@angular/animations';
import { BreadCrumbsService } from './services/bread-crumbs/bread-crumbs.service';
import { MatDialog } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
import { NestedNavigationService } from './services/nested-navigation/nested-navigation.service';
import { ToolbarActionsService, ToolbarActionType } from './services/toolbar-actions/toolbar-actions.service';
import { appSettings } from './modules/shared/components/appSettings';
import { SharedFiltersService } from './services/shared-filters/shared-filters.service';
import { TdMediaService } from '@covalent/core/media';
import { TdDigitsPipe, tdRotateAnimation } from '@covalent/core/common';
import { TdLayoutManageListComponent } from '@covalent/core/layout';
import { ApiService } from './services/api/api.service';
import { NotificationsService } from './services/notifications/notifications.service';
import { ToastrService } from 'ngx-toastr';
import { SwUpdate } from '@angular/service-worker';
import { PwaService } from './services/pwa/pwa';
import { interval } from 'rxjs';
import { TdDialogService } from '@covalent/core/dialogs';
import { environment } from '../environments/environment';
import { Permissions } from './config/AppEnums';
import { AppSettingsService } from './services/app-settings/app-settings.service';
declare var ng: any;
declare var _: any;
const STORAGE_KEY_REDIRECT = 'redirectUrl';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [
    tdRotateAnimation
  ]
})


export class AppComponent {
  title = 'SIMA';
  userProfile: object
  loadingRouteConfig: boolean;
  mainPanelClass: any = "main-panel";
  menu = MENU_ITEMS;


  @ViewChild('manageList') manageList: TdLayoutManageListComponent;
  @ViewChild('dialogContent') template: TemplateRef<any>;
  mainNavOpen: boolean = true;

  name = 'UI Platform';

  public currentApplicationVersion = environment.appVersion;
  pie: any[];
  single: any[];
  multi: any[];
  times: any[];

  miniNav: boolean = false;
  mainMiniNav: boolean = false;

  // Theme toggle
  get activeTheme(): string {
    return localStorage.getItem('theme');
  }
  theme(theme: string): void {
    localStorage.setItem('theme', theme);
  }

  // Timeframe
  dateFrom: Date = new Date(new Date().getTime() - (2 * 60 * 60 * 24 * 1000));
  dateTo: Date = new Date(new Date().getTime() - (1 * 60 * 60 * 24 * 1000));

  // Dialog
  config = {
    width: '50%',
    height: '50%',
  };


  usermenu = [{
    title: 'Profile',
    route: '/',
    icon: 'account_box',
  }, {
    title: 'Settings',
    route: '/',
    icon: 'settings',
  },
  ];

  public get isSuperAdmin() {
    return this.auth.hasAnyPermissionsArrDeprecated([Permissions.SuperAdmin])
  }
  ngAfterViewInit(): void {
    // broadcast to all listener observables when loading the page
    var self = this;
    this.media.broadcast();
    this._changeDetectorRef.detectChanges();
    this.auth.onMainMenuChange.subscribe((o) => {
      self.mainNavOpen = o;
    })
  }

  toggleMiniNav(): void {
    this.miniNav = !this.miniNav;
    setTimeout(() => {
      this.manageList.sidenav._animationStarted.next();
    });
  }
  toggleMainMiniNav(): void {
    this.mainMiniNav = !this.mainMiniNav;
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 1);
  }


  openTemplate() {
    this.dialog.open(this.template, this.config);
  }

  // NGX Charts Axis
  axisDigits(val: any): any {
    return new TdDigitsPipe().transform(val);
  }

  axisDate(val: string): string {
    return new DatePipe('en').transform(val, 'hh a');
  }

  mainNavClick() {
    this.mainNavOpen = false
  }
  public set selectedIds(value) {
    if (value && value.length > 0) {
      this.auth.currentOrganisationId = value[0]
    }
  }
  public get selectedIds() {
    return [this.auth.currentOrganisationId];
  }
  public debug: boolean = false;
  public perf: any = { numTicks: 0 }
  private hist: any = new Array();
  public avg: any = 0;
  public notificationsExpanded: boolean = false;
  public notificationsOpened: boolean = false;
  public showOrgs: boolean = false;
  public actionType = ToolbarActionType;
  public forceFiltersHidden: boolean;
  constructor(private router: Router,
    public signalRService: SignalRService,
    public auth: IdentityAuthService,
    @Inject(LOCAL_STORAGE) private storage: StorageService,
    public breadCrumbService: BreadCrumbsService,
    public media: TdMediaService,
    public dialog: MatDialog,
    private _changeDetectorRef: ChangeDetectorRef,
    private _iconRegistry: MatIconRegistry,
    private _domSanitizer: DomSanitizer,
    public nestedNavigationService: NestedNavigationService,
    public toolbarActionsService: ToolbarActionsService,
    public sharedFiltersService: SharedFiltersService,
    private apiService: ApiService,
    public notificationsService: NotificationsService,
    public messageService: ToastrService,
    private update?: SwUpdate,
    public pwaService?: PwaService,

    public dialogService?: TdDialogService,
    public appSettings?: AppSettingsService) {

    //this._iconRegistry.addSvgIconInNamespace('assets', 'covalent',
    //  this._domSanitizer.bypassSecurityTrustResourceUrl
    //    ('https://raw.githubusercontent.com/Teradata/covalent-quickstart/develop/src/assets/icons/covalent.svg')
    //)
    this.subscribeToEvents();
    var _th = this;

    this.updateClient();
    var count = 0;
    var interval;
    //setTimeout(function () {
    //  interval = setInterval(function () {
    //    if (count > 200) {
    //      clearInterval(interval);
    //      var min = 9999999;
    //      var max = 0;
    //      _th.hist.forEach(o => {
    //        if (o.numTicks < min)
    //          min = o.numTicks
    //        if (o.numTicks > max)
    //          max = o.numTicks
    //      })
    //      console.log('avg:' + _th.avg)
    //      console.log('min:' + min)
    //      console.log('max:' + max)
    //      return;
    //    }
    //    _th.perf = ng.profiler.timeChangeDetection({ record: true });
    //    _th.hist.push(_th.perf);
    //    var total = 0;
    //    _th.hist.forEach(o => {
    //      total += o.numTicks
    //    })

    //    _th.avg = Math.round((total / _th.hist.length));
    //    // console.log(_th.avg)
    //    count++;
    //  }, 1000);
    //}, 12000);
    this.auth.userOrganisationsObserver.subscribe(i => {
      this.setupMenu();

    })

    this.auth.currentOrganisationIdObserver.subscribe(i => {
      this.setupMenu();
    })

    this.setupMenu();

  }

  public updateAvail = false;
  public updateClient() {
    var self = this;

    self.update.available.subscribe((event) => {
      console.log('update avail')
      if (self.updateAvail) {
        return;
      }
      console.log('before current', event.current, 'available', event.available);
      self.activateUpdate();
      self.updateAvail = true;
    })

    self.update.activated.subscribe((event) => {
      console.log('updated current', event.current, 'available', event.current)
    })

    if (!self.update.isEnabled) {
      console.log('Not Enabled');
      return;
    }

    interval(6 * 60 * 60 * 30).subscribe(() => {
      console.log('checking for updates');
      self.update.checkForUpdate()
        .then(() => {
          console.log('checking for updates2')

          //self.messageService.info("Updating to new version")
        })
    });


  }

  public activateUpdate() {
    var self = this;
    self.dialogService.openConfirm({
      message: 'Update available, please refresh to load latest',
      acceptButton: 'Reload',
      title: "Update Available"
    }).afterClosed().subscribe((value: any) => {
      if (value)
        self.update.activateUpdate().then(() => location.reload());
    });
  }

  async setupMenu() {
    await this.auth.ensureAppSettingsLoaded();
    this.menu.forEach(item => {
      if (item.permissions) {
        if (this.auth.hasAnyPermissionsArr(item.permissions))
          item.hidden = false;
        else item.hidden = true;
      }

      if (item.children && item.children.length > 0) {
        item.children.forEach(nestedItem => {
          if (nestedItem.permissions) {
            if (this.auth.hasAnyPermissionsArr(nestedItem.permissions))
              nestedItem.hidden = false;
            else nestedItem.hidden = true;
          }
        });
      }

      if (item.data) {
        if (this.auth.hasAnyPermissionsArrDeprecated(item.data))
          item.hidden = false;
        else item.hidden = true;
      }

      if (item.items && item.items.length > 0) {
        item.items.forEach(nestedItem => {
          if (nestedItem.data) {
            if (this.auth.hasAnyPermissionsArrDeprecated(nestedItem.data))
              nestedItem.hidden = false;
            else nestedItem.hidden = true;
          }
        });
      }

    })

    if (this.auth.currentOrganisation) {
      //var app = this.auth.currentOrganisation.apps.filter(o => o.id.toLowerCase() == '3B2CEEDD-0059-4D5F-A750-8B6586CD5478'.toLowerCase());
      //if (app.length > 0) {
      //  appSettings.ovmApiServiceAddress = app[0].appInstance.apiAddress;

      //  this.loadPermissions();
      //}
    }
  }
  public loadPermissions() {
    this.auth.loadOvmPermissions();
  }

  ngOnInit() {

    var capexGroup = this.menu.filter((o) => o.groupName == 'Capex');
    if (capexGroup.length > 0) {
      var wip = capexGroup[0].items.filter((o) => o.title == "Setup")
      if (wip.length > 0)
        wip[0].link = ['/', 'capex', 'divisions', { id_1: this.auth.currentOrganisationId }];
    }

    this.pwaService.messageService = this.messageService;
    this.router.events.subscribe(async event => {
      appSettings.overrideFunctionalCurrencyId = null;
      if (event instanceof RouteConfigLoadStart) {
        this.loadingRouteConfig = true;
      } else if (event instanceof RouteConfigLoadEnd) {
        this.loadingRouteConfig = false;
      }

      if (event instanceof NavigationStart) {
        this.breadCrumbService.navigating = true;

        if (!event.url.includes('/requisition')) {
          console.log("Reset appSettings.supplierCurrency");
          appSettings.supplierCurrency = undefined;
        }

        if (event.url.indexOf("secondaryUrl") != -1) {
          this.loadingRouteConfig = true;
          window.location.href = 'https://' + event.url.replace("secondaryUrl", appSettings.secondaryUrl) + ';organisationId=' + this.auth.currentOrganisationId;;
          return;
        }

        if (event.url == '/') {
          this.toolbarActionsService.route = '';
          this.mainNavOpen = true;
        }
        else this.mainNavOpen = false;
        if (event.url.indexOf("/callback") == -1 && event.url.indexOf("/#id_token") == -1) {
          this.storage.set(STORAGE_KEY_REDIRECT, event.url);
        }
        var orgIdParam = ';organisationId=';
        var customParamsUsed = false;
        var url = event.url;
        if (event.url.indexOf(orgIdParam) != -1) {
          var curAuth = this.auth.currentOrganisationId;
          event.url.substring(event.url.indexOf(orgIdParam) + orgIdParam.length, event.url.indexOf(orgIdParam) + orgIdParam.length + 36)
          this.auth.currentOrganisationId = event.url.substring(event.url.indexOf(orgIdParam) + orgIdParam.length, event.url.indexOf(orgIdParam) + orgIdParam.length + 36);
          customParamsUsed = true;
          url = url.replace(orgIdParam + this.auth.currentOrganisationId, '')
          if (curAuth != this.auth.currentOrganisationId) {
            this.messageService.info('Swithing division ' + (this.auth.currentOrganisation ? 'to ' + this.auth.currentOrganisation.name : ''), 'Switching division')
          }
        }
        this.loadingRouteConfig = true;
        this.breadCrumbService.breadcrumbs = new Array();
        await this.auth.ensureAppSettingsLoaded();
        if (event.url == "/")
          this.mainNavOpen = true;
        if (event.url.indexOf('/ovm/') != -1) {
          var isFlowRules = event.url.indexOf('/ovm/rules/') != -1;
          var prevForceFiltersHidden = this.forceFiltersHidden;

          this.forceFiltersHidden = isFlowRules;
          this.sharedFiltersService.includeAllCheckboxes = isFlowRules;

          if (prevForceFiltersHidden != this.forceFiltersHidden)
            this.sharedFiltersService.loadData();
          if (isFlowRules) {
            this.sharedFiltersService.reportsOpened = false;
            this.sharedFiltersService.advancedFiltersOpened = false;
          }

        }

        if (!this.sharedFiltersService.loadFilter)
          this.sharedFiltersService.advancedFiltersOpened = false;

        var self = this;
        if (customParamsUsed) {
          setTimeout(() => {
            self.router.navigateByUrl(url);
          }, 1)
          return;
        }
      }
      if (event instanceof NavigationEnd) {
        this.loadingRouteConfig = false

        this.breadCrumbService.navigating = false;
      }

      // Set loading state to false in both of the below events to hide the spinner in case a request fails
      if (event instanceof NavigationCancel) {
        this.loadingRouteConfig = false
      }
      if (event instanceof NavigationError) {
        this.loadingRouteConfig = false
      }

    });

  }


  private subscribeToEvents(): void {
    //this.signalRService.connectionEstablished.subscribe(() => {
    //  console.log('app connection established');
    //});

    this.signalRService.newNotification.subscribe((message: any) => {
      console.log(message);
    });
  }

  public toggleMainSideNav() {
    this.mainNavOpen = !this.mainNavOpen
  }

  public clearCache() {
    this.auth.currentOrganisationId = null;
    this.auth.currentProjectId = null;
    window.location.reload();
  }

  public triggerImport() {
    this.apiService.post('/api/config/triggerImport')
      .subscribe(o => {

        this.messageService.info('Import job has been queued', 'Success')
      }, err => {
        this.messageService.error('Could not queue job', 'Failed')
      })
  }

  public triggerExport() {
    this.apiService.post('/api/config/triggerExport')
      .subscribe(o => {

        this.messageService.info('Export job has been queued', 'Success')
      }, err => {
        this.messageService.error('Could not queue job', 'Failed')
      })
  }
  public triggerClosingBalances() {
    this.apiService.post('/api/config/triggerClosingBalances')
      .subscribe(o => {

        this.messageService.info('Import Closing Balances has been queued', 'Success')
      }, err => {
        this.messageService.error('Could not queue job', 'Failed')
      })
  }

  public triggerBOMCatalog() {
    this.apiService.post('/api/config/triggerBOMCatalog')
      .subscribe(o => {

        this.messageService.info('Import BOM Catalog has been queued', 'Success')
      }, err => {
        this.messageService.error('Could not queue job', 'Failed')
      })
  }
  public navHome(e) {
    this.router.navigateByUrl('/');
  }
}
